const colorStatus = {
    data() {
        return {

        }
    },
    methods: {
        tableRowClassName({ row, rowIndex }) {
            // 已签收、已作废、已终止 就不做警示
            if (row.waybillStatus == "yi_qian_shou:waybill_status" || row.waybillStatus == "yi_zuo_fei:waybill_status" || row.waybillStatus == "yi_zhogn_zhi:waybill_status") {
                return "";
            }
            if (row.takeTime) {
                // 提货日期

                const takeTime = new Date(row.takeTime);
                const now = new Date();
                const sameDay =
                    takeTime.getFullYear() === now.getFullYear() &&
                    takeTime.getMonth() === now.getMonth() &&
                    takeTime.getDate() === now.getDate();
                if (sameDay) {
                    // 今天应提：浅绿
                    if (row.takeStatus == "dai_ti_huo:take_status") {
                        return "jytrow";
                    }
                } else {
                    // 已过应提时间未提：黄
                    const takeTime2 = new Date(row.takeTime).getTime(); // 将 takeTime 转换为时间戳
                    const deliveryTime2 = new Date(row.deliveryTime).getTime(); // 将 deliveryTime2 转换为时间戳
                    const nowTime = Date.now();
                    if (
                        takeTime2 < nowTime &&
                        row.takeStatus == "dai_ti_huo:take_status" &&
                        deliveryTime2 > nowTime
                    ) {
                        return "ygjytrow"; // 如果 takeTime 比当前时间早，则返回一个类名，使当前行显示为黄色
                    }
                }
            }
            if (row.deliveryTime) {
                // 交货日期

                const deliveryTime = new Date(row.deliveryTime);
                const now2 = new Date();
                const sameDay2 =
                    deliveryTime.getFullYear() === now2.getFullYear() &&
                    deliveryTime.getMonth() === now2.getMonth() &&
                    deliveryTime.getDate() === now2.getDate();
                if (sameDay2) {
                    // 今天应送：粉红
                    return "jysrow";
                } else {
                    // 已过交货日期：深红
                    const deliveryTime2 = new Date(row.deliveryTime).getTime(); // 将 deliveryTime2 转换为时间戳
                    const nowTime2 = Date.now();
                    if (deliveryTime2 < nowTime2) {
                        return "ygsrow"; // 如果 deliveryTime2 比当前时间早，则返回一个类名，使当前行显示为深红
                    } else {
                        // 未来两天应送：蓝
                        let time1 = this.$TOOLS.getFlexDate(2); //开始时间;
                        let time2 = 0;
                        if (time1) {
                            time1 = time1 + " 23:59:59";
                            time2 = new Date(time1).getTime(); // 将 time1 转换为时间戳
                        }
                        if (time2 > deliveryTime2) {
                            return "wys2row"; //蓝
                        }
                    }
                }
            }

            return ""; // 否则不返回类名
        }

    },
    created() {

    }
}

export default colorStatus







